import { NgModule } from '@angular/core';
import { PriceModule } from '@icc/price';
import { PriceAwningService } from './price-awning.service';

@NgModule({
    imports: [PriceModule],
    providers: [PriceAwningService],
})
export class AwningPriceModule {}
